// extracted by mini-css-extract-plugin
export default {"container":"dropdown_search_folders-module__container--2zDum","error":"dropdown_search_folders-module__error--rTIvQ"};